// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__layout,#__nuxt,#site-container,body,html{\n  height:100%;\n  width:100%;\n  font-family:Circular\n}\nbody{\n  --tw-bg-opacity:1;\n  background-color:rgba(17, 24, 39, var(--tw-bg-opacity));\n  --tw-text-opacity:1;\n  color:rgba(249, 250, 251, var(--tw-text-opacity))\n}\n#site-container{\n  display:flex\n}\n#site-container.isNavigationOpen{\n  overflow:hidden\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
